import { useMutation } from '@tanstack/react-query'

import { deleteResourceLevelRestriction } from '@/features/site/endpoints/restrictions'

export type useDeleteResourceLevelRestrictionMutationResult = ReturnType<
  typeof useDeleteResourceLevelRestrictionMutation
>

export function useDeleteResourceLevelRestrictionMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { customerUuid: string; restrictionId: string }) =>
      deleteResourceLevelRestriction(variables.customerUuid, variables.restrictionId),
  })

  return {
    deleteResourceLevelRestriction: mutateAsync,
    ...mutationResult,
  }
}
